import React from 'react';
// import { Element } from 'react-scroll';
import Element from '~/components/Scroll/Element';

const BreackpointTopic = () => (
  <Element name="breakpoint" />
);

export default BreackpointTopic;
